$(document).ready(function(){
		
	//
	$('.small-refine .refine').on('click', function(e){
		
		e.preventDefault();
		
		$('.small-sort').hide();
		$('aside').show();
		
		$('.small-refine a').removeClass('active');
		$(this).addClass('active');
	});
	
	//
	$('.small-refine .sort').on('click', function(e){
		
		e.preventDefault();
		
		$('aside').hide();
		$('.small-sort').show();
		
		$('.small-refine a').removeClass('active');
		$(this).addClass('active');
	});	
	
	//
	$('select.size option').each(function(){
		
		stock_level = $(this).attr('data-stock_level');
		
		if(stock_level < 1 && stock_level != '')
		{
			$(this).text($(this).text() + ' — On Backorder');
		}
		
	});
	
	//
	$('.search-products a, span.search').on('click', function(e){
		
		e.preventDefault();
				
		$('body').removeClass('small-nav-open');
				
		$('.search-overlay').fadeIn();		
		$('.search-inner textarea').focus();
		
	});
	
	//
	$('.search-inner .close').click(function(e){
		
		e.preventDefault();
		
		$('.search-overlay').fadeOut();		
		$('.search-inner textarea').val('');
		
	});
	
	//
	$('.search-inner textarea').keypress(function(e) {
		
	    if(e.which == 13)
	    {
			e.preventDefault();
	      	location.href = "search/" + encodeURIComponent($(this).val());		  
	    }
	    
	});		
	
	//
	loupify();
	
	//
	$('.thumbs li').on('click', function(e){
		
		e.preventDefault();
		
		$('.thumbs li').removeClass('selected');
		$(this).addClass('selected');
		
		filename = $(this).attr('data-filename');
		
		standard_filename = 'data/product_images/' + filename;
		original_filename = '../data/product_images/originals/' + filename;
		
		//$('.product-image img').attr('src', standard_filename)		
		//$('.product-image').attr('href', original_filename);
		
		//
		new_html = '<a class="product-image" href="' + original_filename + '">' +
		 				'<img src="' + standard_filename + '" />' +
		 			'</a>';
		 			
		 $('.product-image').remove();
		 
		 $('.product .column-1').prepend(new_html);
		 					
		
		loupify();
	});
	
	//
	$('.zoom, .loupe').on('click', function(e){
		
		e.preventDefault();
		
		photo = "../" + $('.product .column-1').attr('data-product-image-original');
		product_title = $('.product h1').text();
		
		lightbox = '<div class="lightbox-overlay"></div>' +
		
					'<div class="lightbox">' +
					
						'<a href="#" class="close"><span>Back <em>to ' + product_title + '</em></span></a>' +
					
						'<img src="' + photo + '" />' +
					
					'</div>';  
					
		$('body').append(lightbox);
				
	});
	
	//
	$('body').on('click', '.lightbox .close', function(e){
		
		e.preventDefault();
		
		$('.lightbox, .lightbox-overlay').remove();
		
	});
	
});

function loupify()
{
	//
	$('.product-image').loupe({
	  width: 200, // width of magnifier
	  height: 200, // height of magnifier
	  loupe: 'loupe' // css class for magnifier
	});
}
